import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Sentinel } from "../../model_gen/sentinel";
import SentinelForm from "./SentinelForm";

interface EditSentinelFormProps {
  sentinel: Sentinel | undefined;
  loading: boolean;
  setLoading?: (loading: boolean) => void;
  isDataLoaded: boolean;
  onSubmit: (formData: any) => void;
  onClose: () => void;
  readOnly?: boolean;
  regenerationEnabled?: boolean;
}

const EditSentinelForm: React.FC<EditSentinelFormProps> = ({
  sentinel,
  loading,
  setLoading,
  isDataLoaded,
  onSubmit,
  onClose,
  readOnly = false,
  regenerationEnabled = false,
}) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    // Force re-render of SentinelForm when sentinel changes
    setKey(prevKey => prevKey + 1);
  }, [sentinel]);

  return (
    <div className="edit-sentinel-container">
      {isDataLoaded ? (
        <SentinelForm
          key={key}
          initialSentinel={sentinel}
          loading={loading}
          setLoading={setLoading}
          onSubmit={onSubmit}
          onClose={onClose}
          submitButtonText="Update Sentinel"
          readOnly={readOnly}
          regenerationEnabled={regenerationEnabled}
        />
      ) : (
        <Spin size="large" />
      )}
    </div>
  );
};

export default EditSentinelForm;
